import { render, staticRenderFns } from "./PopupAd.vue?vue&type=template&id=1937cbd6&"
import script from "./PopupAd.vue?vue&type=script&lang=js&"
export * from "./PopupAd.vue?vue&type=script&lang=js&"
import style0 from "./PopupAd.vue?vue&type=style&index=0&id=1937cbd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports